'use client';

import { Button } from '@common/components';
import { useQuery } from '@tanstack/react-query';

import { AuthQueryOptions } from '@/api';
import { CustomLink } from '@/app/_components/CustomLink';
import { GOV_CODE } from '@/app/donation/constants';
import { DONATION_ROUTES } from '@/constants';
import { openResponsiveDialog } from '@/stores/DrawerStore';

import { JejuCertificateContent } from '../../../(certificate)/_components/JejuCertificateContent';

export const JejuActionButton = ({
  institutionId,
}: {
  institutionId?: number;
}) => {
  const { data: isDonatedToJeju } = useQuery({
    ...AuthQueryOptions['get:/wello/v2/auth/home-donation/my'](),
    select: (data) =>
      data.context?.homeLoveGovCodeList?.includes(GOV_CODE.JEJU) ?? false,
  });

  return (
    <div className="flex w-full gap-8">
      {isDonatedToJeju ? (
        <Button
          theme="primary-fill"
          dimensions="H56"
          className="flex-1"
          onClick={() =>
            openResponsiveDialog({
              component: JejuCertificateContent,
              drawerType: 'bottom',
            })
          }
        >
          인증서 보기
        </Button>
      ) : null}

      <Button
        theme={isDonatedToJeju ? 'primary-line' : 'primary-fill'}
        dimensions="H56"
        asChild
        disabled={!institutionId}
        className="flex-1"
      >
        <CustomLink
          href={DONATION_ROUTES.HOMETOWNS_BUSINESS.withSearchParams({
            searchParams: {
              institutionId,
            },
          })}
          aria-label="제주도 지정기부 페이지로 이동"
          className="w-full"
        >
          기부하기
        </CustomLink>
      </Button>
    </div>
  );
};
